/**
* Instagram JS
* -----------------------------------------------------------------------------
*
* All the JS for the Instagram component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'instagram',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.sbi_instagram_link' ).append( '<div class="flex flex-col gap-y-4 items-center"><p class="hdg-1 !text-white mt-4">Follow Us</p><p class="paragraph-default !text-white">@worthywaterloo</p></div>' );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'instagram', COMPONENT );
} )( app );
